import MyDocument from '@/views/MyDocument/index.vue'

const MyDocumentRouter = {
  path: '/my-document',
  name: 'MyDocument',
  component: MyDocument,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default MyDocumentRouter
